import { useState, useEffect } from "react";
import { supa } from "./firebase";
import { Trash } from 'iconoir-react'

function ModalInfoUser({ setVisible, aggiorna, utente }) {
    const [nome, setNome] = useState(utente.nome)
    const [cognome, setCognome] = useState(utente.cognome)
    const [birth, setBirth] = useState(utente.birth)

    const [lezioni, setLezioni] = useState([])
    const [pacchettiAcquistati, setPacchettiAcquistati] = useState([])

    const [lezioniEffettuate, setLezioniEffettuate] = useState([])


    async function getLezioni() {
        const { data, error } = await supa
            .from('lezioni')
            .select('*,utenti(*),personalTrainer(*),pacchettiAcquistati(*,pacchetti(*))')
            .eq('id_utente', utente.id)
        if (error) console.log("---", error)
        data.sort((a, b) => new Date(a.data) - new Date(b.data))
        setLezioni(data)
    }

    async function getPacchettiAcquistati() {
        const { data, error } = await supa
            .from('pacchettiAcquistati')
            .select('*,pacchetti(*)')
            .eq('id_utente', utente.id)
        if (error) console.log("---", error)
            data.sort((a, b) => new Date(a.inizio) - new Date(b.inizio))
        setPacchettiAcquistati(data)
    }

    async function patchUtente() {
        const { data, error } = await supa
            .from('utenti')
            .update({ "nome": nome, "cognome": cognome, "birth": birth })
            .eq('id', utente.id)
        if (error) console.log(error)
        aggiorna()
        setVisible(false)
    }

    async function alertPatch() {
        if (window.confirm(`Sei sicuro di voler salvare le modifiche?`)) {
            patchUtente()
        }
    }


    useEffect(() => {
        getLezioni()
        getPacchettiAcquistati()
    }, [])


    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm overflow-y-auto">
            <div className="relative w-full max-w-7xl mx-4 my-8 animate-in fade-in zoom-in duration-200">
                <div className="relative bg-white rounded-2xl shadow-2xl border border-zinc-200">
                    {/* Header */}
                    <div className="flex items-center justify-between p-6 border-b border-zinc-200">
                        <div>
                            <h3 className="text-2xl font-bold text-zinc-900">Info Utente</h3>
                            <p className="text-sm text-zinc-600 mt-1">Modifica le informazioni dell'utente</p>
                        </div>
                        <button 
                            onClick={() => setVisible(false)} 
                            className="p-2 text-zinc-400 hover:text-zinc-600 hover:bg-zinc-100 rounded-lg transition-all"
                        >
                            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    {/* Body */}
                    <form className="p-6">
                        <div className="grid gap-6 mb-6 md:grid-cols-2">
                            <div>
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Nome</label>
                                <input 
                                    type="text" 
                                    onChange={(e) => setNome(e.target.value.toLocaleUpperCase())} 
                                    value={nome} 
                                    className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all" 
                                    placeholder="Inserisci nome"
                                />
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Cognome</label>
                                <input 
                                    type="text" 
                                    onChange={(e) => setCognome(e.target.value.toLocaleUpperCase())} 
                                    value={cognome} 
                                    className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all" 
                                    placeholder="Inserisci cognome"
                                />
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Data di nascita</label>
                                <input 
                                    type="date" 
                                    value={birth} 
                                    onChange={(e) => setBirth(e.target.value)} 
                                    className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all"
                                />
                            </div>

                            <div className="md:col-span-2 mt-4">
                                <div className="flex justify-between items-center mb-3">
                                    <label className="text-sm font-semibold text-zinc-700">Pacchetti Acquistati</label>
                                    <span className="text-sm font-semibold text-zinc-900 bg-zinc-100 px-3 py-1 rounded-lg">{pacchettiAcquistati?.length}</span>
                                </div>
                                <div className="bg-zinc-50 border border-zinc-200 rounded-xl overflow-hidden h-64">
                                    <div className="overflow-y-auto h-full noBar">
                                        <table className="w-full text-left text-sm">
                                            <thead className="bg-zinc-100 sticky top-0 z-10 border-b border-zinc-200">
                                                <tr>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">Pacchetto</th>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">Inizio</th>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">Fine</th>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">Totale</th>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">Acconto</th>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">Rimanente</th>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">Sed. Pacchetto</th>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">Sed. Effettuate</th>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">Completato</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pacchettiAcquistati?.map((item, index) => (
                                                    <tr key={index} className="border-b border-zinc-200 hover:bg-zinc-50/50">
                                                        <td className="px-4 py-3 text-zinc-900">{item?.pacchetti?.nome}, {item?.totale} €</td>
                                                        <td className="px-4 py-3 text-zinc-600">{item?.inizio ? new Date(item?.inizio).toLocaleDateString('it-IT') : ""}</td>
                                                        <td className="px-4 py-3 text-zinc-600">{item?.fine ? new Date(item?.fine).toLocaleDateString('it-IT') : ""}</td>
                                                        <td className="px-4 py-3 text-zinc-900">{item?.totale} €</td>
                                                        <td className="px-4 py-3 text-zinc-600">{item?.acconto} €</td>
                                                        <td className="px-4 py-3 text-zinc-900 font-semibold">{item?.totale - item?.acconto} €</td>
                                                        <td className="px-4 py-3 text-zinc-600">{item?.pacchetti?.num_lezioni}</td>
                                                        <td className="px-4 py-3 text-zinc-900">{item?.sedute_effettuate}</td>
                                                        <td className="px-4 py-3">
                                                            <input type="checkbox" checked={item?.completato} readOnly className='w-4 h-4 cursor-default accent-yellow-400 rounded' />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div className="md:col-span-2 mt-4">
                                <div className="flex justify-between items-center mb-3">
                                    <label className="text-sm font-semibold text-zinc-700">Lezioni Effettuate</label>
                                    <span className="text-sm font-semibold text-zinc-900 bg-zinc-100 px-3 py-1 rounded-lg">{lezioni?.length}</span>
                                </div>
                                <div className="bg-zinc-50 border border-zinc-200 rounded-xl overflow-hidden h-72">
                                    <div className="overflow-y-auto h-full noBar">
                                        <table className="w-full text-left text-sm">
                                            <thead className="bg-zinc-100 sticky top-0 z-10 border-b border-zinc-200">
                                                <tr>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">Data</th>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">Personal Trainer</th>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">Pacchetto</th>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">Tipo Lezione</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {lezioni?.map((item, index) => (
                                                    <tr key={index} className="border-b border-zinc-200 hover:bg-zinc-50/50">
                                                        <td className="px-4 py-3 text-zinc-900">{item?.data ? new Date(item?.data).toLocaleDateString('it-IT') : ""}</td>
                                                        <td className="px-4 py-3 text-zinc-900">{item?.personalTrainer?.nome} {item?.personalTrainer?.cognome}</td>
                                                        <td className="px-4 py-3 text-zinc-600">{item.pacchettiAcquistati?.pacchetti.nome}</td>
                                                        <td className="px-4 py-3">
                                                            <span className={`px-2 py-1 rounded-lg text-xs font-semibold ${item?.pacchettiAcquistati?.tipo == "0" ? "bg-blue-100 text-blue-700" : "bg-purple-100 text-purple-700"}`}>
                                                                {item?.pacchettiAcquistati?.tipo == "0" ? "Personal" : "Pilates"}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="flex items-center justify-end gap-3 pt-4 border-t border-zinc-200">
                            <button 
                                type="button"
                                onClick={() => setVisible(false)}
                                className="px-5 py-2.5 text-sm font-semibold text-zinc-700 bg-zinc-100 hover:bg-zinc-200 rounded-xl transition-all"
                            >
                                Annulla
                            </button>
                            <button 
                                type="button"
                                onClick={() => alertPatch()}
                                className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-zinc-900 bg-yellow-400 hover:bg-yellow-500 rounded-xl shadow-sm hover:shadow transition-all"
                            >
                                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                </svg>
                                Salva Modifiche
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ModalInfoUser;
